/**
 * @fileoverview Test Calendar Feature Constants
 * @description Feature-specific constants for the Test Calendar module
 */

export const EVENT_STATUSES = {
  PLANNED: 'PLANNED',
  IN_PROGRESS: 'IN_PROGRESS',
  EXTENDED: 'EXTENDED',
  COMPLETED: 'COMPLETED',
  CLOSED_EARLY: 'CLOSED_EARLY',
  CANCELLED: 'CANCELLED',
  ON_HOLD: 'ON_HOLD',
};

export const EVENT_STATUS_LABELS = {
  [EVENT_STATUSES.PLANNED]: 'Planned',
  [EVENT_STATUSES.IN_PROGRESS]: 'In Progress',
  [EVENT_STATUSES.EXTENDED]: 'Extended',
  [EVENT_STATUSES.COMPLETED]: 'Completed',
  [EVENT_STATUSES.CLOSED_EARLY]: 'Closed Early',
  [EVENT_STATUSES.CANCELLED]: 'Cancelled',
  [EVENT_STATUSES.ON_HOLD]: 'On Hold',
};

export const EVENT_STATUS_COLORS = {
  [EVENT_STATUSES.PLANNED]: '#4A90D9',
  [EVENT_STATUSES.IN_PROGRESS]: '#F5A623',
  [EVENT_STATUSES.EXTENDED]: '#9013FE',
  [EVENT_STATUSES.COMPLETED]: '#00AF66',
  [EVENT_STATUSES.CLOSED_EARLY]: '#50E3C2',
  [EVENT_STATUSES.CANCELLED]: '#E31837',
  [EVENT_STATUSES.ON_HOLD]: '#8B8B8B',
};

export const PRIORITY_OPTIONS = [
  { value: 'LOW', label: 'Low', color: '#8B8B8B' },
  { value: 'MEDIUM', label: 'Medium', color: '#4A90D9' },
  { value: 'HIGH', label: 'High', color: '#F5A623' },
  { value: 'CRITICAL', label: 'Critical', color: '#E31837' },
];

export const PRIORITY_COLORS = {
  LOW: '#8B8B8B',
  MEDIUM: '#4A90D9',
  HIGH: '#F5A623',
  CRITICAL: '#E31837',
};

/**
 * Valid status transitions per the backend state machine
 */
export const STATUS_TRANSITIONS = {
  [EVENT_STATUSES.PLANNED]: [EVENT_STATUSES.IN_PROGRESS, EVENT_STATUSES.CANCELLED, EVENT_STATUSES.ON_HOLD],
  [EVENT_STATUSES.IN_PROGRESS]: [EVENT_STATUSES.EXTENDED, EVENT_STATUSES.COMPLETED, EVENT_STATUSES.CLOSED_EARLY, EVENT_STATUSES.CANCELLED, EVENT_STATUSES.ON_HOLD],
  [EVENT_STATUSES.EXTENDED]: [EVENT_STATUSES.IN_PROGRESS, EVENT_STATUSES.COMPLETED, EVENT_STATUSES.CLOSED_EARLY, EVENT_STATUSES.CANCELLED, EVENT_STATUSES.ON_HOLD],
  [EVENT_STATUSES.ON_HOLD]: [EVENT_STATUSES.IN_PROGRESS, EVENT_STATUSES.CANCELLED],
  [EVENT_STATUSES.COMPLETED]: [],
  [EVENT_STATUSES.CLOSED_EARLY]: [],
  [EVENT_STATUSES.CANCELLED]: [],
};

export const CALENDAR_VIEWS = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
};

export const RECURRENCE_OPTIONS = [
  { value: '', label: 'None' },
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'BIWEEKLY', label: 'Bi-weekly' },
  { value: 'MONTHLY', label: 'Monthly' },
];
